import { PaymentMethodType } from "@/types";

export const PAYMENT_METHODS = {
  check: {
    type: 'check' as PaymentMethodType,
    label: 'Check',
    subType: null,
    threshold: 75
  },
  bank_transfer_international: {
    type: 'bank_transfer_international' as PaymentMethodType,
    label: 'Bank Transfer (International)',
    subType: 'International',
    threshold: 50
  },
  bank_transfer_us: {
    type: 'bank_transfer_us' as PaymentMethodType,
    label: 'Bank Transfer (US Local)',
    subType: 'US Local',
    threshold: 0
  },
  paypal: {
    type: 'paypal' as PaymentMethodType,
    label: 'PayPal',
    subType: null,
    threshold: 0
  }
};

export const TICKET_CATEGORIES = [
  { value: 'payment', label: 'Payment Issues' },
  { value: 'royalty', label: 'Royalty Reports' },
  { value: 'account', label: 'Account Management' },
  { value: 'other', label: 'Other' }
];

export const TICKET_PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' }
];

export const TICKET_STATUSES = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' }
];
